<template>
  <div class="container mx-auto">
    <router-link to="/partners">
      <a
        href="#"
        class="relative inline-flex items-center my-4 py-2 leading-5 font-medium text-lg font-semibold
         transition ease-in-out duration-150 text-lightFont hover:text-darkFont uppercase"
      >
        <LeftArrow class="mr-2" /> Back to Partners
      </a>
    </router-link>
    <div
      class="bg-white  max-w-7xl mx-auto rounded-t-xl rounded-br-xl lg:rounded-t-2xl lg:rounded-br-2xl border-vectric border-8"
      v-if="partner"
    >
      <div
        class="relative max-w-screen-xl mx-auto p-12 sm:p-6 lg:p-12 speaker-info"
      >
        <div class="lg:grid lg:grid-cols-2 lg:gap-8">
          <div>
            <div class="mx-auto text-base">
              <p
                class="leading-6 text-black uppercase font-bold tracking-tight  text-xl"
              >
                Meet the Partner
              </p>
              <h1
                class="mt-3  text-4xl leading-snug tracking-wider text-black uppercase"
              >
                {{ partner.name }}
              </h1>
            </div>
            <div
              class="lg:prose text-gray-900 lg:row-start-1 lg:col-start-1"
              v-if="partner.bio"
            >
              <block-content :blocks="partner.bio" :serializers="serializers">
              </block-content>
            </div>
          </div>
          <div class="relative mb-8 lg:mb-0 lg:row-start-1 lg:col-start-2">
            <div
              class="relative text-gray-800 mx-auto lg:max-w-prose lg:max-w-none block md:flex lg:block"
            >
              <figure class="lg:w-full w-full md:w-1/2">
                <div
                  class="relative my-6 sm:my-12 md:mb-0 lg:my-0 h-full sm:h-96 md:pb-0 md:h-auto"
                >
                  <img
                    :src="portrait"
                    alt=""
                    class="rounded-full  w-1/3 object-cover object-center sm:absolute inset-0 sm:w-2/3 mx-auto lg:static lg:h-auto"
                  />
                </div>
              </figure>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sanityClient } from "../utils/sanity";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import BlockContent from "sanity-blocks-vue-component";
import RichTextImage from "../components/RichTextImage";
import RichTextGallery from "../components/RichTextGallery";
import LeftArrow from "../components/shared/LeftArrow.vue";
export default {
  name: "Partner",
  components: {
    LeftArrow,
    BlockContent
  },
  data() {
    return {
      partner: null,
      serializers: {
        types: {
          image: RichTextImage,
          gallery: RichTextGallery
        }
      }
    };
  },
  created() {
    const id = this.$route.params.id;
    const queryString = `*[_type == 'partner' && _id == $id][0]{...
    }`;
    sanityClient
      .fetch(queryString, { id })
      .then(res => {
        this.partner = res;
      })
      .catch(function(err) {
        console.error(err);
      });
  },
  methods: {},
  computed: {
    portrait() {
      if (this.partner) {
        return sanityImageBuilder
          .image(this.partner.portrait)
          .height(400)
          .width(400)
          .url();
      }
      return "";
    }
  }
};
</script>

<style scoped></style>
